import styled from 'styled-components';

export const MainContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
    background-color: transparent;

    @media screen and (max-width: 1100px) {
        width: 100%;
        margin-left: 0;
        margin-right: 0;
        font-size: 14px;
    }

    @media screen and (max-width: 800px) {
        width: 100%;
        margin-left: 0;
        margin-right: 0;
        font-size: 14px;
    }

    @media screen and (max-width: 575px) {
        max-width: 100%;
        margin-left: 0;
        margin-right: 0;
        font-size: 12px;
    }
`;

export const BodyContainer = styled.div`
    //background: #FFDF8B80;
    //border: 1px solid var(--border-color);
    border-radius: 16px;
    //box-shadow: 0 18px 45px rgba(78, 58, 10, 0.14);
    margin: 2rem auto;
    max-width: 100%;
    padding: 3rem 4rem 2rem;
    width: calc(100% - 2rem);

    @media screen and (max-width: 1100px) {
        max-width: 900px;
    }

    @media screen and (max-width: 800px) {
        padding: 1.25rem;
    }

    @media screen and (max-width: 575px) {
        border-radius: 12px;
        margin: 0.75rem auto;
        padding: 0.9rem 0.75rem 1.25rem;
        width: calc(100% - 1rem);
    }
`;

export const BodyRow = styled.div`
    padding: 0.45rem 0;
`;

export const FormHeaderContent = styled.div`
    //background: var(--raised-surface-color);
    //border: 1px solid var(--border-color);
    //border: 1px solid #F1B924;
    //border-left: 4px solid var(--accent-color);
    border-radius: 12px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: start;
    margin-bottom: 2rem;
    padding: 0.9rem 0;
    width: 100%;
`;

export const FormHeading = styled.h1`
    font-size: 2.2rem;
    font-weight: 700;
    color: var(--text-color);
    line-height: 1.15;
    margin: 0.25rem 0 2rem;
    text-align: left;
    width: 100%;

    @media screen and (max-width: 575px) {
        font-size: 1.65rem;
    }
`;

export const FormSecondHeading = styled.h2`
    font-size: 18px;
    font-weight: 700;
    color: var(--text-color);
    display: flex;
    justify-content: flex-start;
    margin-bottom: 1rem;
    width: 100%;
`;

export const FormThirdHeading = styled.h3`
    font-size: 16px;
    font-weight: 400;
    line-height: 1.5;
    color: var(--text-color);
    display: flex;
    justify-content: flex-start;
    margin-bottom: 0.35rem;
    opacity: 0.78;
    width: 100%;
`;

export const CalculatorForm = styled.form`
    color: var(--text-color);

    > ${BodyRow},
    .body-row {
        //background: var(--raised-surface-color);
        background: transparent;
        //border: 1px solid var(--border-color);
        //border: 1px solid #F1B924;
        //border-radius: 12px;
        margin-bottom: 2rem;
        padding: 0.8rem 0;
    }

    .form-label {
        color: var(--text-color);
        font-size: 0.8rem;
        font-weight: 600;
        margin-bottom: 0.25rem;
    }

    .form-control,
    .form-select {
        //background-color: var(--field-surface-color);
        //border-color: #d9cba9;
        border-color: #F1B924;
        color: var(--text-color);
        min-height: 40px;
    }

    .form-control:focus,
    .form-select:focus {
        background-color: #fffdf7;
        border-color: var(--accent-color);
        box-shadow: 0 0 0 0.2rem rgba(212, 160, 23, 0.18);
    }

    .form-check-input:checked {
        background-color: var(--accent-color);
        border-color: #a87808;
    }

    .addons-grid {
        display: grid;
        gap: 0.5rem 1rem;
        grid-template-columns: 1fr;
        margin-top: 0.65rem;
    }

    @media screen and (max-width: 575px) {
        > ${BodyRow},
        .body-row {
            border-radius: 10px;
            padding: 0.7rem;
        }

        .form-control,
        .form-select {
            min-height: 44px;
        }

    }
`;

export const CalculatorStepper = styled.div`
    display: grid;
    gap: 0.55rem;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    margin-bottom: 2rem;
`;

export const CalculatorStep = styled.div`
    align-items: center;
    // background: ${({ $active }) => ($active ? '#fff3c7' : 'var(--raised-surface-color)')};
    // border: 1px solid ${({ $active }) => ($active ? 'var(--accent-color)' : 'var(--border-color)')};
    border-radius: 8px;
    color: var(--text-color);
    background: ${({ $active }) => ($active ? '#F1B924' : '#FFDF8B80')};
    display: flex;
    font-size: 0.82rem;
    font-weight: 700;
    gap: 0.55rem;
    min-width: 0;
    padding: 0.55rem 0.7rem;

    @media screen and (max-width: 575px) {
        flex-direction: column;
        font-size: 0.68rem;
        gap: 0.25rem;
        padding: 0.45rem 0.25rem;
        text-align: center;
    }
`;

export const CalculatorStepNumber = styled.span`
    align-items: center;
    // background: ${({ $active }) => ($active ? 'var(--accent-color)' : 'var(--border-color)')};
    background: ${({ $active }) => ($active ? '#FAFAFA' : '#FAFAFA')};
    border-radius: 50%;
    color: var(--text-color);
    display: inline-flex;
    flex: 0 0 24px;
    font-size: 0.72rem;
    font-weight: 700;
    height: 24px;
    justify-content: center;
    width: 24px;
`;

export const CalculatorActions = styled(BodyRow)`
    align-items: center;
    //border-top: 1px solid var(--border-color);
    display: flex;
    justify-content: space-between;
    margin-top: 0.35rem;
    padding-top: 0.9rem;

    .btn {
        //border-radius: 999px;
        border-radius: 15px;
        font-weight: 700;
        min-height: 40px;
        min-width: 110px;
        padding: 0.45rem 1.1rem;
    }

    .btn-success {
        background: var(--accent-color);
        border-color: var(--accent-color);
        color: var(--text-color);
    }

    .btn-success:hover,
    .btn-success:focus {
        background: var(--accent-hover-color);
        border-color: var(--accent-hover-color);
        color: var(--text-color);
    }

    @media screen and (max-width: 575px) {
        .btn {
            min-height: 44px;
        }
    }
`;

export const HeaderImage = styled.div`
    width: 100%;
    height: auto;
    display: inline-flex;
    justify-content: center;
    align-items: center;

    @media screen and (max-width: 575px) {
        margin-top: 2.5rem;
        margin-bottom: 2.5rem;
    }
`;

export const SubmitButton = styled.button`
    border-radius: 999px;
    font-weight: 700;
    min-height: 40px;
    width: 100%;

    @media (min-width: 992px) {
        width: 30%;
    }
`;

export const FormColCheck = styled.div`
    justify-content: center;
    align-content: center;
    margin-top: 10px;
    padding-left: 25px;
`;
